import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { Select, Store } from '@ngxs/store';
import { Subject } from 'rxjs';
// import { ViewOrder } from '../../../../shared/action/order.action';
// import { GetOrderStatus } from '../../../../shared/action/order-status.action';
// import { OrderState } from '../../../../shared/state/order.state';
// import { OrderStatusState } from '../../../../shared/state/order-status.state';
import {
  MissingProduct,
  Order,
  OrderModel,
  OrderStatus,
  PaymentMethod,
  PaymentStatus,
  ReOrderResponseModel,
  ReturnRequest
} from '@/app/shared/interface/order.interface';
import { OrderService } from '@/app/shared/services/order.service';
// import { OrderStatusModel } from '../../../../shared/interface/order-status.interface';
// import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { CartService } from '@/app/shared/services/cart.service';
import { BankInfo, QRData } from '@/app/shared/interface/qrcode.interface';
import { QRCodeService } from '@/app/shared/services/qrcode.service';
import { isPlatformBrowser } from '@angular/common';
import { ReturnOrderModalComponent } from '../../return-order/modal/return-order-modal.component';
import { BaseResponseDataModel, BaseResponseModel } from '@/app/shared/interface/base-response.interface';
import { ReturnOrderListModalComponent } from '../../return-order/list/modal/return-order-list-modal.component';
import { ShipmentListModalComponent } from "@/app/components/account/shipments/list/modal/shipment-list-modal.component";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { OrderShippingModalComponent } from '../order-shipping/modal/order-shipping-modal/order-shipping-modal.component';
import { PAYMENT_METHOD } from '../../../../shared/constants/common.constant';
import { OrderTemplateService } from '@/app/shared/services/order-template.service';
import { normalizeOrderTemplateError } from '@/app/shared/utils/order-template-error';
import { ConfigurationV2Service } from '@/app/shared/services/configuration-v2.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})


export class OrderDetailsComponent {


  @ViewChild('returnOrderModal') returnOrderModal: ReturnOrderModalComponent;
  @ViewChild('orderShippingModal') orderShippingModal: OrderShippingModalComponent;
  @ViewChild('returnOrderListModal') returnOrderListModal: ReturnOrderListModalComponent;
  @ViewChild('shipmentListModal') shipmentListModal: ShipmentListModalComponent;

  // @Select(OrderStatusState.orderStatus) orderStatus$: Observable<OrderStatusModel>;

  private destroy$ = new Subject<void>();

  public order: Order;
  public missingProducts: MissingProduct[] = [];
  public isReadyReturnOrder = false;
  public returnOrders: ReturnRequest[];

  headerColumns = [
    "Sản phẩm",
    "Số lượng khách đặt",
    "Số lượng giao thực tế",
    "Đơn giá (đ)",
    "Thành tiền (đ)"
  ];

  headerColumnsForMisingProducts = [
    "STT",
    "Sản phẩm",
    "Số lượng giao thiếu",
    "Giá",
    "Tổng cộng"
  ];

  baseUrl = 'https://qr.sepay.vn/img';
  qrImgSrc: string;
  qrData: QRData = {
    accNo: '',
    accName: '',
    bank: '',
    amount: 0,
    des: ''
  }

  createdOrderStatus = OrderStatus.Created;
  paidOrderStatus = OrderStatus.Paid;
  cancelledOrderStatus = OrderStatus.Cancelled;
  paymentMethod = PAYMENT_METHOD;

  isSavingTemplate: boolean = false;
  isSavedTemplate: boolean = false;
  canReOrder: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private toastService: ToastrService,
    private cartService: CartService,
    private qrCodeService: QRCodeService,
    private sanitizer: DomSanitizer,
    private orderTemplateService: OrderTemplateService,
    private configV2Service: ConfigurationV2Service,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    // this.store.dispatch(new GetOrderStatus());
  }

  ngOnInit() {
    this.route.params.subscribe({
      next: (res: any) => {
        if (res["id"]) {
          this.getOrderDetail(res["id"]);
          this.getMissingOrderProducts(res["id"]);
        }
      }
    })
  }

  getOrderDetail(orderId: string) {
    const body = {
      orderId: orderId
    }
    this.orderService.getOrders(JSON.stringify(body)).subscribe({
      next: (res: OrderModel) => {
        if (res && res.orderHistory) {
          const o = res.orderHistory.find(o => o.orderId === orderId);
          if (o) {
            this.order = o;
            const paymentMethod = this.paymentMethod.find(pm => pm.code === this.order.paymentMethod);

            if (paymentMethod) {
              this.order.paymentMethod = paymentMethod.label;
              this.getBankInfo();
            } else {
              console.error('Phương thức thanh toán không hợp lệ:', this.order.paymentMethod);
            }

            this.checkReturnOrder();
            this.getReturnOrder();
            this.checkCanReOrder();
          }
        }
      }
    });
  }

  getMissingOrderProducts(orderId: string) {
    this.orderService.getMissingOrderProducts(orderId).subscribe({
      next: (res: MissingProduct[]) => {
        this.missingProducts = res;
      },
      error: (err) => {
        console.error('Lỗi khi lấy sản phẩm thiếu trong đơn hàng:', err);
        this.missingProducts = [];
      }
    });
  }

  getBankInfo() {
    this.qrCodeService.getBankInfo().subscribe({
      next: (res: BankInfo) => {
        if (res) {
          this.qrData.accNo = res.bankNumber;
          this.qrData.accName = res.bankName;
          this.qrData.bank = res.bankCode;
          this.qrData.amount = this.order.finalPrice;
          this.qrData.des = `${res.prefix}${this.order.globalOrderId}`;

          this.qrImgSrc = `${this.qrCodeService.baseUrl}?acc=${this.qrData.accNo}&bank=${this.qrData.bank}&amount=${this.qrData.amount}&des=${this.qrData.des}`;
        }
      },
      error: (err) => console.log(err)
    });
  }

  copyToClipboard(value: string) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(value);
    }
    this.toastService.success("Sao chép mã đơn hàng thành công!", "", { positionClass: "toast-top-right" });
  }

  getOrderStatus(status: OrderStatus) {
    switch (status) {
      case OrderStatus.Created:
        return { value: "Đang xác nhận", icon: "created" };
      case OrderStatus.Progressing:
        return { value: "Đang xử lý", icon: "progressing" };
      // case OrderStatus.Packing:
      //   return { value: "Đã Đóng Gói", icon: "progressing"}
      case OrderStatus.Shipping:
        return { value: "Đang vận chuyển", icon: "shipping" };
      case OrderStatus.Done:
        return { value: "Đã Hoàn Thành", icon: "done" };
      case OrderStatus.Cancelled:
        return { value: "Đã hủy", icon: "cancelled" };
      case OrderStatus.Paid:
        return { value: "Đã thanh toán", icon: "paid" };
      case OrderStatus.PartialPaid:
        return { value: "Thanh toán một phần", icon: "partial-paid" };
      case OrderStatus.Slipted:
        return { value: "Đã tách đơn", icon: "slipted" };
      default:
        return { value: "Không xác định", icon: "progressing" };
    }
  }
  getPaymentStatus(status: PaymentStatus | undefined) {
    switch (status) {
      case PaymentStatus.Paid:
        return { value: "Đã thanh toán", icon: "paid" };
      case PaymentStatus.Unpaid:
        return { value: "Chưa thanh toán", icon: "unpaid" };
      case PaymentStatus.PartialPaid:
        return { value: "Thanh toán một phần", icon: "partial-paid" };
      default:
        return { value: "Chưa thanh toán", icon: "unpaid" };
    }
  }

  // Đơn đã hoàn thành: cho đặt lại ngay. Chưa hoàn thành: phải qua số ngày cấu hình TimeRangePreventReOrder kể từ ngày đặt.
  checkCanReOrder() {
    if (this.order.orderStatus === OrderStatus.Done || this.order.orderStatus === OrderStatus.Cancelled) {
      this.canReOrder = true;
      return;
    }
    this.configV2Service.getConfigrationV2('TimeRangePreventReOrder').subscribe({
      next: (res: any) => {
        const days = Number(res?.[0]?.configJsonValue);
        if (!Number.isFinite(days)) {
          this.canReOrder = false;
          return;
        }
        if (!this.order.orderDate) {
          this.canReOrder = false;
          return;
        }
        const orderTime = new Date(this.order.orderDate).getTime();
        if (Number.isNaN(orderTime)) {
          this.canReOrder = false;
          return;
        }
        const MS_PER_DAY = 24 * 60 * 60 * 1000;
        const daysSinceOrder = (Date.now() - orderTime) / MS_PER_DAY;
        this.canReOrder = daysSinceOrder >= days;
      },
      error: () => this.canReOrder = false
    });
  }

  reOrder() {
    this.orderService.reOrder(this.order.orderId).subscribe({
      next: (res: ReOrderResponseModel) => {
        if (res) {
          if (res.isSuccess) {
            this.toastService.success("Đã thêm các sản phẩm vào giỏ hàng");
            if (res.data.length) {
              this.toastService.info(
                "Một số SP/đơn hàng không còn khả dụng (tạm hết hàng hoặc dừng bán), vui lòng kiểm tra lại giỏ hàng trước khi đặt hàng!",
                "",
                { timeOut: 10000 }
              );
            }
            this.cartService.refreshCart();
            this.router.navigateByUrl('/cart');
          } else {
            if (res.message) {
              console.log("Reoder message: ", res.message);
            }
            if (res.data.length) {
              this.toastService.error("Tất cả SP/đơn hàng này không còn khả dụng, vui lòng kiểm tra lại hoặc liên hệ với nhân viên để được tư vấn!");
            } else {
              this.toastService.error("Đặt hàng lại lỗi, vui lòng thử lại sau");
            }
          }
        }
      },
      error: (err: any) => {
        this.toastService.error(err.error.message);
        this.cartService.refreshCart();
      }
    })

  }

  downloadQRCode() {
    this.qrCodeService.downloadQRCode(this.qrImgSrc, this.order.orderId);
  }

  returnOrder() {
    this.returnOrderModal.openModal(this.order);
  }

  orderShippingStatus(trachkingUrl: string | undefined, trackingNumber: string) {
    this.orderShippingModal.openModal(trachkingUrl, trackingNumber, this.order.orderId);
  }

  checkReturnOrder() {
    if (this.order && this.order.orderId) {
      this.orderService.checkReturnOrder(this.order.orderId).subscribe({
        next: (res: BaseResponseModel) => {
          if (res && res.isSuccess) {
            this.isReadyReturnOrder = true;
          } else {
            this.isReadyReturnOrder = false;
          }
        },
        error: (error: any) => {
          console.error(error);
          this.isReadyReturnOrder = false;
        }
      })
    } else {
      this.isReadyReturnOrder = false;
    }
  }

  getReturnOrder() {
    if (this.order) {
      this.orderService.retrieveReturnOrder(this.order.userName, this.order.orderId).subscribe({
        next: (res: ReturnRequest[]) => {
          this.returnOrders = res;
        },
        error: (error: any) => {
          console.error(error);
          this.returnOrders = [];
        }
      })
    }
  }

  viewReturnOrderList() {
    this.returnOrderListModal.openModal(this.order, this.returnOrders);
  }

  viewShipmentList() {
    this.shipmentListModal.openModal(this.order, this.order.shipments || []);
  }

  // isPdf(url?: string | null): boolean {
  //   if (!url) return false;
  //   return /\.pdf($|\?)/i.test(url);
  // }
  //
  // isImage(url?: string | null): boolean {
  //   if (!url) return false;
  //   if (url.startsWith('data:image')) return true;
  //   return /\.(jpe?g|png|gif|bmp|webp|svg)($|\?)/i.test(url);
  // }
  //
  // getSafeInvoiceUrl(url?: string): SafeResourceUrl {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url || '');
  // }
  public isGettingInvoice: { [key: string]: boolean } = {};

  getOrderInvoice(invCode: string) {
    if (!this.order) {
      this.toastService.error("Chưa chọn đơn hàng");
      return;
    }
    if (this.isGettingInvoice.hasOwnProperty(invCode) === false) {
      this.isGettingInvoice[invCode] = false;
    }

    this.isGettingInvoice[invCode] = true;
    let newTab = window.open('', '_blank');

    if (!newTab) {
      alert('Mở trang mới bị chặn. Vui lòng cho phép mở tab mới để xem Hóa đơn.');
      return;
    }

    this.orderService.getOrderInvoiceUrl(this.order.orderId, invCode).subscribe({
      next: (res: BaseResponseDataModel<string>) => {
        if (res.isSuccess) {
          newTab!.location.href = res.data;
        } else {
          console.error(res);
          newTab!.close();
          this.toastService.error("Có lỗi khi lấy hóa đơn, vui lòng thử lại sau");
        }
      },
      error: (err: any) => {
        newTab!.close();
        this.toastService.error("Có lỗi khi lấy hóa đơn, vui lòng thử lại sau.");
        console.error(err);
        this.isGettingInvoice[invCode] = false;
      },
      complete: () => {
        this.isGettingInvoice[invCode] = false;
      }
    });
  }

  saveAsOrderTemplate(): void {
    if (!this.order?.orderId || this.isSavingTemplate) return;
    this.isSavingTemplate = true;
    const templateName = 'Đơn hàng ' + this.order.orderId;
    this.orderTemplateService.createFromOrder({
      orderId: this.order.orderId,
      name: templateName
    }).subscribe({
      next: (res) => {
        this.isSavingTemplate = false;
        if (res?.isSuccess) {
          this.isSavedTemplate = true;
          this.toastService.success('Đã lưu thành đơn hàng thường xuyên thành công!', '', {
            positionClass: 'toast-top-right'
          });
        } else {
          this.toastService.error(normalizeOrderTemplateError(res).message, '', {
            positionClass: 'toast-top-right'
          });
        }
      },
      error: (err) => {
        this.isSavingTemplate = false;
        console.error('Error saving template from order:', err);
        const msg = normalizeOrderTemplateError(err).message;
        this.toastService.error(msg, '', {
          positionClass: 'toast-top-right'
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
